<template>
  <div
    v-if="!isTemplate && showFlsaSidebar"
    class="flsa-toggle"
  >
    <v-btn
      variant="outlined"
      min-width="48"
      width="48"
      class="flsa-icon"
      :active="currentTab === 'flsa'"
      @click="setCurrentTab('flsa')"
    >
      <v-icon icon="mdi-scale-balance" />
    </v-btn>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { useCurrentJobProfile } from '@/stores/jobProfiles/currentJobProfile';
import { useDocumentRightPanel } from '@/stores/document/rightPanel';

const { authData } = storeToRefs(useAppAuthData());

const showFlsaSidebar = computed(() => (
  authData.value.jobProfileEnabled
    && (authData.value.accessLevel === 3 || authData.value.flsaEnabled)
));

const { currentTab } = storeToRefs(useDocumentRightPanel());
const { setCurrentTab } = useDocumentRightPanel();

const { isTemplate } = storeToRefs(useCurrentJobProfile());
</script>

<style lang="less" scoped>
.flsa-icon {
  border-color: @stroke-default;

  :deep(.v-icon) {
    color: @icon-default;
  }
}
</style>
